import React, { useRef, useState, useEffect } from "react";
import API_BASE_URL from "../../../apiconfig";
import { useNavigate } from "react-router-dom";

import logoutUser from "./logoutUser";

function PhotoSign({ onNext, onPrev }) {

    const navigate = useNavigate();
    const [alertData, setAlertData] = useState(null);
    const showAlert = (message, type = "error") => {
        setAlertData({
            message,
            type,
            id: Date.now()
        });

        setTimeout(() => {
            setAlertData(null);
        }, 5000);
    };


    const fileRef = useRef();
    const signRef = useRef();   // ✅ NEW

    const [preview, setPreview] = useState(null);
    const [signPreview, setSignPreview] = useState(null);  // ✅ NEW

    const [photoFile, setPhotoFile] = useState(null);
    const [signFile, setSignFile] = useState(null);



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhotoFile(file); // 🔥 store file
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSignChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSignFile(file); // 🔥 store file
            setSignPreview(URL.createObjectURL(file));
        }
    };
    const handleUpload = async () => {

        // ===============================
        // 1️⃣ VALIDATION (before API call)
        // ===============================
        if (!photoFile) {
            showAlert("Please upload photograph ❗", "error");
            return;
        }

        if (!signFile) {
            showAlert("Please upload signature ❗", "error");
            return;
        }

        try {
            const token = sessionStorage.getItem("token");

            const formData = new FormData();
            formData.append("photo", photoFile);
            formData.append("signature", signFile);

            const response = await fetch(
                `${API_BASE_URL}/API/Student/SAVE_PHOTO_SIGN`,
                {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + token
                    },
                    body: formData
                }
            );

            const result = await response.text();

            // ===============================
            // 2️⃣ HANDLE RESPONSE
            // ===============================
            if (!response.ok) {
                showAlert(result || "Upload failed ❗", "error");
                return;
            }

            if (result === "SAVED") {
                showAlert("Photo & Signature uploaded successfully ✅", "success");

                // 👉 move next if needed
                setTimeout(() => {
                    onNext && onNext();
                }, 600);

            } else {
                // 👉 AI validation message
                showAlert(result, "error");
            }

        } catch (err) {
            console.error(err);
            showAlert("Something went wrong ❗", "error");
        }
    };

    const [photoUrl, setPhotoUrl] = useState(null);
    const [signUrl, setSignUrl] = useState(null);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const token = sessionStorage.getItem("token");

                const res = await fetch(`${API_BASE_URL}/API/Student/GET_PHOTO_SIGN`, {
                    headers: {
                        Authorization: "Bearer " + token
                    }
                });

                if (res.status === 401 || res.status === 403) {

                    logoutUser(navigate);
                    return;
                }

                if (!res.ok) {
                    console.error("Failed to fetch program");
                    return;
                }

                const data = await res.json();

                if (res.ok) {

                    const photoBase64 = "data:image/jpeg;base64," + data.photo;
                    const signBase64 = "data:image/jpeg;base64," + data.signature;

                    // 👉 set preview
                    setPhotoUrl(photoBase64);
                    setSignUrl(signBase64);

                    // 👉 ALSO set file (🔥 THIS FIXES YOUR ISSUE)
                    setPhotoFile(base64ToFile(photoBase64, "photo.jpg"));
                    setSignFile(base64ToFile(signBase64, "sign.jpg"));
                }

            } catch (err) {
                console.error(err);
            }
        };

        fetchImages();
    }, []);

    const base64ToFile = (base64, fileName) => {
        const arr = base64.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    };

    const [isPaymentDone, setIsPaymentDone] = useState(false);

    useEffect(() => {
        const checkPaymentStatus = async () => {
            try {
                const token = sessionStorage.getItem("token");

                const response = await fetch(
                    `${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": "Bearer " + token
                        }
                    }
                );

                if (!response.ok) return;

                const result = await response.json(); // boolean true/false
                console.log("Payment Done:", result);

                setIsPaymentDone(result);



            } catch (error) {
                console.error("Error checking payment:", error);
            }
        };

        checkPaymentStatus();
    }, []);

    const [isEditOn, setIsEditOn] = useState(false);
    useEffect(() => {
        const checkPaymentStatus = async () => {
            try {
                const token = sessionStorage.getItem("token");

                const response = await fetch(
                    `${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": "Bearer " + token
                        }
                    }
                );

                if (!response.ok) return;

                const result = await response.json();
                console.log("edit response:", result);

                setIsEditOn(result);



            } catch (error) {
                console.error("Error checking payment:", error);
            }
        };

        checkPaymentStatus();
    }, []);

    //const canEdit = !isPaymentDone || isEditOn === false;
	const canEdit = isEditOn === false;


    return (
        <div className="container">

            <style>{`
				
		@keyframes smoothEntry {
		0% {
			opacity: 0;
		    transform: translateY(20px);
  	  }
		100% {
		   opacity: 1;
		   transform: translateY(0);
		 }
		}
        .container {
          max-width: 900px;
          margin: 25px auto;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 18px 20px;
          font-family: Arial;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
		  animation: smoothEntry 0.4s ease;
        }

		.title {
		          font-size: 16px;
		          font-weight: 600;
		          color: #065f46;
		          margin-bottom: 12px;
		        }

        .row {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          margin-bottom: 15px;
        }

        .left {
          flex: 1;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          padding: 12px;
          border-radius: 6px;
          font-size: 13px;
          line-height: 1.6;
          min-height: 140px; 
        }
		
		.left-sign {
	     flex: 1;
		 background: #f8fafc;
	     border: 1px solid #e2e8f0;
		 padding: 12px;
		 border-radius: 6px;
		 font-size: 13px;
		 line-height: 1.6;
		 min-height: 80px; 
		 }

        .right {
          width: 160px;
          text-align: center;
        }

        .upload-box {
          width: 140px;
          height: 160px;
          border: 1px dashed #94a3b8;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: #f9fafb;
          transition: 0.2s;
          overflow: hidden;
        }

        /* 🔥 SIGNATURE SMALL */
        .sign-box {
          height: 100px;
        }

        .upload-box:hover {
          border-color: #059669;
          background: #ecfdf5;
        }

        .upload-box img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

		.label {
		  margin-top: 6px;
		  font-size: 12.5px;
		  font-weight: 600;
		  color: #1f2937;
		  letter-spacing: 0.3px;
		  text-align: center;
		}
		/* BUTTONS ALIGN */
				.footer {
				  display: flex;
				  justify-content: space-between;
				  margin-top: 16px;
				}

				.btn {
				  padding: 6px 14px;
				  font-size: 13px;
				  border-radius: 6px;
				  border: none;
				  cursor: pointer;
				}

				.prev {
				  background: #e2e8f0;
				}

				.next {
				  background: #059669;
				  color: #fff;
				}
      `}</style>

            {alertData && (
                <div className={`custom-alert ${alertData.type}`}>
                    <span className="alert-icon">
                        {alertData.type === "success" ? "✔" : "❗"}
                    </span>
                    {alertData.message}
                </div>
            )}


            <div className="title">
                Upload Photo & Signature:
            </div>

            {/* PHOTO */}
            <div className="row">

                <div className="left">
                    <b>Instruction For Photograph:</b><br />
                    ⇒ Size of photograph must be less than 35 kb.<br />
                    ⇒ Height of photograph must be between 250 pixel and 320 pixel.<br />
                    ⇒ width of photograph must be between 150 pixel and 220 pixel.
                </div>

                <div className="right">
                    <div
                        className="upload-box"
                        onClick={() => fileRef.current.click()}
                    >
                        {preview ? (
                            <img src={preview} />
                        ) : photoUrl ? (
                            <img src={photoUrl} />
                        ) : (
                            "Click to Upload"
                        )}
                    </div>

                    <div className="label">Photograph</div>

                    <input
                        type="file"
                        ref={fileRef}
                        onChange={handleFileChange}
                        accept="image/*"
                        hidden
                        disabled={!canEdit}
                    />
                </div>

            </div>

            {/* SIGNATURE */}
            <div className="row">

                <div className="left-sign">
                    <b>Instruction For Signature:</b><br />
                    ⇒ Size of signature must be less than 30 kb.<br />
                    ⇒ Height of signature must be between 100 pixel and 180 pixel.<br />
                    ⇒ width of signature must be between 150 pixel and 220 pixel.
                </div>

                <div className="right">
                    <div
                        className="upload-box sign-box"
                        onClick={() => signRef.current.click()}
                    >
                        {signPreview ? (
                            <img src={signPreview} />
                        ) : signUrl ? (
                            <img src={signUrl} />
                        ) : (
                            "Click to Upload"
                        )}
                    </div>

                    <div className="label">Signature</div>

                    <input
                        type="file"
                        ref={signRef}
                        onChange={handleSignChange}
                        accept="image/*"
                        hidden
                        disabled={!canEdit}
                    />
                </div>

            </div>

            {/* Footer */}
            <div className="footer">
                <button className="btn prev" onClick={onPrev} >⬅ Previous</button>
                <button className="btn next" onClick={handleUpload}>
                    Next ➜
                </button>
            </div>

        </div>


    );
}

export default PhotoSign;